{
    "type": {
        "new": "Nouveau",
        "unchanged": "Inchangé",
        "added": "Ajouté",
        "removed": "Retiré",
        "updated": "Modifié"
    },
    "value": {
        "false": "Non",
        "true": "Oui"
    },
    "placeholder": {
        "empty": "Vide",
        "truncated": "Tronqué",
        "object": "Objet"
    },
    "label": {
        "collapseAll": "Alt + clic pour tout replier",
        "expandAll": "Alt + clic pour tout déplier"
    }
}
